import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { AboutPayload } from '../types';

export const fetchAbout = async (): Promise<AboutPayload | null> => {
  const response = await fetch(API_ENDPOINTS.aboutIntroduction, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`About introduction request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as AboutPayload) : null;
  }

  return data as AboutPayload;
};
